import { VFC } from 'react';
import { Col, Container, Row } from 'react-grid-system';
import styled from 'styled-components';
import { useSettings } from '../../contexts/settingsContext';
import { tProductListItem } from '../../contexts/zod';
import { EASYCOM_ROUTES } from '../../navigation';
import { theme } from '../../utils/theme';
import Spacing from '../atoms/Spacing';
import Typography from '../atoms/Typography';
import IconButton from '../molecules/IconButton';
import ProductImage from '../molecules/ProductImage';
import TableItem from '../molecules/TableItem';
import { useAppNavigate } from '../../hooks/useAppNavigate';

interface Props {
  radius: string;
}

const Border = styled(Container)<Props>`
  background-color: white;
  border-radius: ${({ radius }) => `${radius}`};
  border: 1px solid #e0e0e0;
  padding-top: 32px;
  padding-bottom: 32px;
`;

const ProductListItem: VFC<tProductListItem> = ({
  productNumber,
  productDescription,
  variant,
  variantDescription,
  imageUrl,
}) => {
  const navigate = useAppNavigate();
  const { cornerRadius: radius } = useSettings();

  const table = [
    {
      title: <Typography translateKey="art_no" variant="body1-semi-bold" />,
      value: `${productNumber}${variant}`,
    },
    {
      title: (
        <Typography translateKey="product_name" variant="body1-semi-bold" />
      ),
      value: productDescription,
    },
    {
      title: (
        <Typography
          translateKey="product_variant"
          variant="body1-semi-bold"
        />
      ),
      value: variantDescription,
    },
  ];

  return (
    <>
      <Border radius={radius}>
        <Col>
          <Row justify="end" align="start">
            <ProductImage src={imageUrl} />
            <Col>
              <Row>
                <Spacing horizontal spacing={2} />
                {table.map(({ title, value }) => (
                  <TableItem key={value} title={title} value={value} />
                ))}
              </Row>
            </Col>
            <IconButton
              icon="arrow-right"
              iconColor={theme.colors.grey[100]}
              backgroundColor={theme.colors.grey[40]}
              onClick={() =>
                navigate(
                  `${EASYCOM_ROUTES.PRODUCT_PAGE}/${productNumber}/${variant}`,
                )
              }
            />
          </Row>
        </Col>
      </Border>
      <Spacing spacing={4} />
    </>
  );
};

export default ProductListItem;
